import React from 'react'

const Divider = () => {
  return (
    <div className='mt-3 mb-3 bg-secondary w-100' style={{ height: '1px' }} />
  )
}

export default Divider
